export const castBondCCurrencyCode = (cCurrencyCode: string | (string | null)[] | null | undefined) => {
  if (!cCurrencyCode || Array.isArray(cCurrencyCode) || !(cCurrencyCode === 'EUR' || cCurrencyCode === 'USD' || cCurrencyCode === 'foreign')) {
    return undefined;
  }
  return cCurrencyCode;
};
